import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useSimplifiedCommPreferences = () =>
  useFlag(LaunchDarklyFlag.ENABLE_SIMPLIFIED_COMMUNICATION_PREFERENCES) === 'true';
